import { AppState } from '@core/state';
import { createChildSelectors } from '@util/lib/ngrx-child-selectors';

import { initialState } from './order.reducers';

export const selectOrderState = (state: AppState) => state.order;

export const { selectDetail, selectUpdateItem, selectAddItem } = createChildSelectors(selectOrderState, initialState);

export const {
  selectDisplay: selectAddItemDisplay,
  selectStep: selectAddItemStep,
  selectItem: selectAddItemItem,
  selectDescription: selectAddItemDescription,
  selectLotNumber: selectAddItemLotNumber,
  selectPassthru: selectAddItemPassthru,
  selectQuantity: selectAddItemQuantity,
  selectUom: selectAddItemUom,
  selectWeight: selectAddItemWeight,
  selectWeightOrUom: selectAddItemWeightOrUom,
} = createChildSelectors(selectAddItem, initialState.addItem);

export const {
  selectDisplay: selectUpdateItemDisplay,
  selectLotNumber: selectUpdatemLotNumber,
  selectUom: selectUpdateItemUOM,
  selectWeightOrUom: selectUpdateItemWeightOrUOM,
  selectQuantity: selectUpdateItemQuantity,
  selectWeight: selectUpdateItemWeight,
  selectWeightUom: selectUpdateItemWeightUom,
  selectItem: selectUpdateItemItem,
} = createChildSelectors(selectUpdateItem, initialState.updateItem);
